import axios from "axios"

export const api = axios.create({
  baseURL: process.env.NEXT_PUBLIC_API_URL,
  withCredentials: true,
})

// JWT interceptor (если решишь хранить токен в памяти)
api.interceptors.request.use((config) => {
  const token = typeof window !== "undefined"
    ? sessionStorage.getItem("access_token")
    : null

  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }

  return config
})